import { useTheme } from '@mui/material';
import { useFormikContext } from 'formik';
import { useMemo } from 'react';
import { FormField } from '../../../../components/FormField/FormField';
import { Multiselect } from '../../../../components/Multiselect/Multiselect';
import { SelectItem, UserRole } from '../../../../types';
import { useUsers } from '../../../../queries/hooks/useUsers';
import { IUserFileds } from './UserModal';
import { useSelectedWorkflow } from './useSelectedWorkflow';
import { hasRole } from '../../../../utils/roles';

/**
 * SVP Manager (approver) picker. Renders only when the selected workflow has an SVP_MANAGER approval
 * stage. Candidates are users with the OP Manager role (same pool as the Managers picker), excluding
 * the user being edited. Bound to the `svpManagers` relation.
 */
export function SvpManagerField() {
  const { colors } = useTheme();
  const { data: users } = useUsers();
  const { setFieldValue, values, setFieldTouched } = useFormikContext<IUserFileds>();
  const { hasSvpStage } = useSelectedWorkflow();

  const svpManagerOptions = useMemo(() => {
    if (!users) return [];
    return users
      .filter((user) => hasRole(user, UserRole.OP_MANAGER) && user.email !== values.email)
      .map((user) => ({ id: user.id, value: user.name }));
  }, [users, values.email]);

  if (!hasSvpStage) {
    return null;
  }

  return (
    <FormField label={'SVP Managers'} labelStyle={{ color: colors.text.caption }}>
      <Multiselect
        listboxStyle={{ height: '195px' }}
        options={svpManagerOptions}
        value={values?.svpManagers as SelectItem[]}
        onChange={(_, svpManagers) => {
          setFieldValue('svpManagers', svpManagers);
        }}
        onBlur={() => {
          setFieldTouched('svpManagers');
        }}
        disablePortal
        fieldPlaceholder='Select SVP managers'
      />
    </FormField>
  );
}
